/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Add from './Add/index'
import Edit from './Edit/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let scheduleNoteModeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'mode',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: scheduleNoteModeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Add'}>
<Add
  viewPath={`${viewPath}/Add`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Edit'}>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}